import React, { Component } from 'react';
import { Link } from 'react-router-dom';

export default class OrderHistoryBreadCrumbs extends Component {

  render() {
    const { id } = this.props;
    return (
      <nav>
        <div className="breadcrumbs">
          <div className="breadcrumb">
            <Link to="/">Home</Link>
          </div>
          <div className="breadcrumb">
            { id &&
            <Link to="/orderhistory/">Order History</Link>
            }
            { !id &&
            <span>Order History</span>
            }
          </div>
          { id &&
          <div className="breadcrumb">
            <span>{id}</span>
          </div>
          }
        </div>
      </nav>
    )
  }
}
